/* eslint-disable import/prefer-default-export */
export const FORM_STEPS = [1, 2, 3];
